module.exports = __webpack_public_path__ + "static/media/Stitch-Shop.8092c2cd.jpg";